var _excluded = ["barLinks", "account", "logo", "navigation", "cart", "backLink", "mobileNavigationBackLinkText", "onHeaderLoad", "onHeaderVisibilityChange", "searchInput", "hamburgerOnClick", "isDarkMode", "hasHideBoxShadow", "bottomBarContent"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useRef, useState } from "react";
import styled, { css } from "styled-components";
import BrandContext from "../../../contexts/BrandContext";
import IsDarkModeContext from "../../../contexts/IsDarkModeContext";
import OnColorContext from "../../../contexts/OnColorContext";
import pageHeaderBrandStyles from "../../../theme/pageHeaderBrandStyles";
import breakpoint from "../../../utils/breakpoint";
import isNotEmpty from "../../../utils/isNotEmpty";
import space from "../../../utils/space";
import BarOrg from "./components/BarOrg";
import BottomBarOrg from "./components/BottomBarOrg";
import MainOrg from "./components/MainOrg";
import { barHeightSpaceOnDesktop, barHeightSpaceOnMobile, breakpointValue, hugeBreakpointValue, mainHeightSpaceOnDesktop, mainHeightSpaceOnMobile } from "./components/settings";
var Wrapper = styled.header.withConfig({
  componentId: "sc-6qb6ez-0"
})(function (_ref) {
  var $hasBarLinks = _ref.$hasBarLinks;
  return css(["height:", ";overflow:hidden;", "{overflow:initial;}", "{height:", ";}"], space(barHeightSpaceOnMobile + mainHeightSpaceOnMobile), breakpoint(breakpointValue), breakpoint(hugeBreakpointValue), space(($hasBarLinks ? barHeightSpaceOnDesktop : 0) + mainHeightSpaceOnDesktop));
});
function PageHeaderOrg(_ref2) {
  var barLinks = _ref2.barLinks,
    account = _ref2.account,
    logo = _ref2.logo,
    navigation = _ref2.navigation,
    cart = _ref2.cart,
    backLink = _ref2.backLink,
    mobileNavigationBackLinkText = _ref2.mobileNavigationBackLinkText,
    onHeaderLoad = _ref2.onHeaderLoad,
    onHeaderVisibilityChange = _ref2.onHeaderVisibilityChange,
    searchInput = _ref2.searchInput,
    hamburgerOnClick = _ref2.hamburgerOnClick,
    isDarkMode = _ref2.isDarkMode,
    hasHideBoxShadow = _ref2.hasHideBoxShadow,
    bottomBarContent = _ref2.bottomBarContent,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHeaderSticky = _useState2[0],
    setIsHeaderSticky = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isBottomBarSticky = _useState4[0],
    setIsBottomBarSticky = _useState4[1];
  var wrapperRef = useRef(null);
  var barRef = useRef(null);
  var _pageHeaderBrandStyle = pageHeaderBrandStyles[useContext(BrandContext)],
    background = _pageHeaderBrandStyle.background,
    backgroundDark = _pageHeaderBrandStyle.backgroundDark;
  var hasBarLinks = barLinks && Object.keys(barLinks).length !== 0;
  return /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: isDarkMode ? backgroundDark : background
  }, /*#__PURE__*/React.createElement(IsDarkModeContext.Provider, {
    value: isDarkMode
  }, /*#__PURE__*/React.createElement(Wrapper, _extends({
    ref: wrapperRef,
    $hasBarLinks: !!hasBarLinks,
    role: "banner"
  }, restProps), hasBarLinks ? /*#__PURE__*/React.createElement(BarOrg, {
    barLinks: barLinks,
    account: account,
    ref: barRef
  }) : null, /*#__PURE__*/React.createElement(MainOrg, {
    logo: logo,
    navigation: navigation,
    cart: cart,
    backLink: backLink,
    searchInput: searchInput,
    mobileNavigationBackLinkText: mobileNavigationBackLinkText,
    wrapperRef: wrapperRef,
    barRef: barRef,
    onHeaderLoad: onHeaderLoad,
    onHeaderVisibilityChange: onHeaderVisibilityChange,
    hamburgerOnClick: hamburgerOnClick,
    isDarkMode: isDarkMode,
    hasHideBoxShadow: !!hasHideBoxShadow,
    hasBottomBar: isNotEmpty(bottomBarContent),
    isHeaderSticky: isHeaderSticky,
    setIsHeaderSticky: setIsHeaderSticky,
    setIsBottomBarSticky: setIsBottomBarSticky
  })), isNotEmpty(bottomBarContent) ? /*#__PURE__*/React.createElement(BottomBarOrg, {
    isSticky: isBottomBarSticky,
    isHeaderSticky: isHeaderSticky,
    headerWrapperRef: wrapperRef,
    headerBarRef: barRef
  }, bottomBarContent) : null));
}
export default PageHeaderOrg;